// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3hVwA","label":"LabeledBox_label__rlF_k"};